import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityModelConfiguration } from '../../enums/entityModelConfiguration';
import {
  CimClass,
  EMCType,
  EntityModelCustomizationService,
  GetEMCConfigurationDataIn,
  SectionDefinition,
  SubstationTemplateService,
  SubstationTemplateUICustomizationDto,
  UtilitySharedService,
} from 'shared-lib';

@Component({
  selector: 'app-entity-model-customization',
  templateUrl: './entity-model-customization.component.html',
  styleUrl: './entity-model-customization.component.scss',
  standalone: false,
})
export class EntityModelCustomizationComponent implements OnInit {
  mainTabItems: string[] = [
    'Assets',
    'Operations',
    'Meter Management',
    'Equipments',
  ];
  selectedMainTab: string = this.mainTabItems[0];
  entityType: EMCType = EMCType.TransmissionStation;
  cimClass?: CimClass | undefined = CimClass.PowerTransformer;
  CimClass = CimClass;
  EMCType = EMCType;
  utilityId: number;
  currentId: number;
  EMCConfiguration: EntityModelConfiguration[] = [];
  substationTemplates: SubstationTemplateUICustomizationDto[] = [];
  selectedSubstationTemplate: SubstationTemplateUICustomizationDto | null = null;
  sectionDefinitions: SectionDefinition[] = [];
  equipmentSectionDefinitions: SectionDefinition[] = [];
  classes: SectionDefinition[] = [];
  voltage: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private emcService: EntityModelCustomizationService,
    private utilitySharedService: UtilitySharedService,
    private substationTemplateService: SubstationTemplateService
  ) {}

  ngOnInit(): void {
    this.utilityId = this.utilitySharedService.getUtilityId()!;
    this.currentId = Number(this.route.snapshot.paramMap.get('id'));
    this.getSelectedMainTabByUrlId();
    if (this.selectedMainTab == 'Equipments') {
      this.selectCimClass(CimClass.PowerTransformer);
    } else {
      this.selectEntityModel(this.entityType);
    }
    this.loadSubstationTemplates();
  }

  loadSubstationTemplates() {
    this.substationTemplateService.getAllForSidebar(this.utilityId).subscribe({
      next: (response: any) => {
        var data = response?.body?.data;
        this.substationTemplates = data || [];
        
        if (this.substationTemplates.length && this.selectedMainTab != 'Equipments') {
          const firstTpl = this.substationTemplates[0];
          this.selectEntityModel(EMCType.SubstationTemplate, firstTpl.id);
        }
      },
    });
  }

  selectCimClass(cimClass: CimClass) {
    this.entityType = EMCType.EquipmentTemplate;
    this.cimClass = cimClass;
    this.selectedSubstationTemplate = null;
    // if (type === EMCType.SubstationTemplate && substationTemplateId != null) {
    //   this.selectedSubstationTemplate =
    //     this.substationTemplates.find((t) => t.id === substationTemplateId) ??
    //     null;
    // }
    // this.getEMCConfiguration(substationTemplateId);
  }

  selectEntityModel(type: EMCType, substationTemplateId?: number | null) {
    this.entityType = type;
    this.selectedSubstationTemplate = null;
    if (type === EMCType.SubstationTemplate && substationTemplateId != null) {
      this.selectedSubstationTemplate =
        this.substationTemplates.find((t) => t.id === substationTemplateId) ??
        null;
    }
    this.getEMCConfiguration(substationTemplateId);
  }

  private getEMCConfiguration(substationTemplateId?: number | null) {
    var obj = new GetEMCConfigurationDataIn();
    obj.type = this.entityType;
    obj.utilityId = this.utilityId;
    obj.substationTemplateId = substationTemplateId || undefined;
    this.emcService.getConfigurationByType(obj).subscribe({
      next: (response: any) => {
        var data = response?.body?.data;
        this.EMCConfiguration = data.map(
          (s: any) =>
            EntityModelConfiguration[
              s as keyof typeof EntityModelConfiguration
            ],
        );
        this.setConfigToLocalStorage();
      },
    });
  }

  private setConfigToLocalStorage() {
    localStorage.removeItem('EMCConfiguration');
    localStorage.setItem(
      'EMCConfiguration',
      JSON.stringify(this.EMCConfiguration),
    );
  }

  selectMainTab(tab: string, index: number): void {
    this.currentId = Number(this.route.snapshot.paramMap.get('id'));
    this.selectedMainTab = tab;
    if (this.selectedMainTab == 'Assets') {
      if (this.substationTemplates.length) {
        this.selectEntityModel(EMCType.SubstationTemplate, this.substationTemplates[0].id);
      } else{
        this.selectEntityModel(EMCType.TransmissionStation);
      }
      this.cimClass = undefined;
    } else if (this.selectedMainTab == 'Equipments') {
      this.selectCimClass(CimClass.PowerTransformer);
      this.selectedSubstationTemplate = null;
    }
    if (this.currentId !== index) {
      this.router.navigate(['../', index], {
        relativeTo: this.route,
        replaceUrl: true,
      });
    }
  }

  getSelectedMainTabByUrlId() {
    switch (this.currentId) {
      case 0:
        this.selectedMainTab = this.mainTabItems[0];
        break;
      case 1:
        this.selectedMainTab = this.mainTabItems[1];
        break;
      case 2:
        this.selectedMainTab = this.mainTabItems[2];
        break;
      case 3:
        this.selectedMainTab = this.mainTabItems[3];
        break;
      default:
        break;
    }
    this.cdr.detectChanges();
  }

  handleBackButtonClicked() {
    this.utilitySharedService.removeUtilityId();
    this.router.navigate(['settings-bps/utility-management']);
  }
}
